import { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import ChargeManagementEditViewModel from "viewModels/chargeManagement/chargeManagementEdit/chargeManagementEditViewModel";
import Icon, { IconType } from "@edaz/edazkit/Icon";

const ChargeManagementHeader: ViewComponent<ChargeManagementEditViewModel> = observer(({ vm }) => (
  <div className="mb-7 mx-0 px-0">
    <Row>
      <Col md="auto" className="position-md-absolute z-index-1">
        <Button onClick={vm.back} variant="link" className="font-weight-bold px-0 py-2 d-flex align-items-center link-underline">
          <div
            className={"bg-danger d-flex align-items-center justify-content-center rounded-circle text-white mr-2"}
            style={{ height: 40, width: 40 }}>
            <Icon icon={IconType.ArrowLeft} width={12} height={12} />
          </div>
          {vm.translate("back")}
        </Button>
      </Col>
      <Col className="text-center">
        <h2 className="mb-0 text-wrap">{vm.vehicle}</h2>
        {vm.isRefunded ? <span className="invalidated-heading">{vm.translate("invalid")}</span> : <span>{vm.authCode}</span>}
      </Col>
    </Row>
  </div>
));

export default ChargeManagementHeader;
